import { withDropdownMenu } from "ui";
import { MdArrowDropDown, MdArrowLeft, MdArrowRight } from "react-icons/md";
import React from "react";
import { DropdownMenuContext } from "ui/common/dropdown-menu/types";
import { NavigateToNewDraftInjectedProps, withNavigateToNewDraft } from 'app/area/case/components/enhancers/navigate-to-new-draft';
import { containerFactory } from 'app/infrastructure/redux/container-factory';
import { actionCreators } from 'app/area/case/draft/actions';
import { NewCaseButtonsWireData } from 'app/area/case/features/calls-to-actions/types';
import styles from './add-new-connected-cases-dropdown.scss';
import { dropdownRefContextMenu, isMobileScreen, isWindowLargeEnough } from "app/components/helpers";

interface AddNewConnectedCasesDropdownProps {
  entityId: number;
  addNewConnectedCaseButtons: NewCaseButtonsWireData[];
  textLabelMenu: string;
  key: number;
  path?: any[];
  returnToModalParent?: boolean;
}

interface AddNewConnectedCasesButtonComponentProps extends AddNewConnectedCasesDropdownProps {
  labelTextButton: string;
  caseType: number;
  connectionTypeId: number;
  isReadOnly: boolean;
  entityId: number;
}

const AddNewConnectedCasesButtonComponent = (props: AddNewConnectedCasesButtonComponentProps & NavigateToNewDraftInjectedProps) => {

  const onClickAddNewConnectedCase = () => (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    props.navigateToNewDraft();
  };

  return (
    !props.isReadOnly && 
      <li key={props.key}>
        <button id="nav-refresh-cache-button" className={"dropdown-item"} type="button" onClick={onClickAddNewConnectedCase()}>
          {props.labelTextButton}
        </button>
      </li>
  );
};

const AddNewConnectedCasesButton: React.ComponentType<AddNewConnectedCasesButtonComponentProps> =
  containerFactory(withNavigateToNewDraft(AddNewConnectedCasesButtonComponent, true), actionCreators, undefined);

export const AddNewConnectedCasesDropdown = withDropdownMenu((props: DropdownMenuContext & AddNewConnectedCasesDropdownProps) => {

  const hideComponent = 
    props.addNewConnectedCaseButtons?.every(addNewConnectedCaseButton => 
      addNewConnectedCaseButton.attributes.find(attr => attr.name === 'component.readOnly')?.value.toLowerCase() === 'true');

  return <>
    {!hideComponent && <li className={styles.nestedDropdown} key={props.key}>
      <div className="dropdown-item" tabIndex={0}>
        <span>{props.textLabelMenu}</span>
        <div className={styles.icon}>
          {isMobileScreen() ? <MdArrowDropDown className={`dropdown-arrow ${styles.navItemIcon}`}/> : 
            isWindowLargeEnough() ? <MdArrowRight className={`dropdown-arrow ${styles.navItemIcon}`} /> : 
            <MdArrowLeft className={`dropdown-arrow ${styles.navItemIcon}`} />}
        </div>
      </div>
      <ul key={props.key} className={`dropdown-menu ${styles.subMenu}`} ref={dropdownRefContextMenu}>
        {props.addNewConnectedCaseButtons?.map((addNewConnectedCaseButton: NewCaseButtonsWireData, index: number) => {
          const caseType = Number(addNewConnectedCaseButton?.attributes?.find(attr => attr.name === 'component.caseType')?.value);
          const connectionType = 
            Number(addNewConnectedCaseButton?.attributes?.find(attr => attr.name === 'component.connectionTypeId')?.value);
          const isReadOnly = 
            addNewConnectedCaseButton?.attributes?.find(attr => attr.name === 'component.readOnly')?.value.toLowerCase() === 'true';

          return (
          <AddNewConnectedCasesButton
            key={index} labelTextButton={addNewConnectedCaseButton.label} caseType={caseType}
            connectionTypeId={connectionType} isReadOnly={isReadOnly}
            entityId={props.entityId}
            {...props} />
            );
          })
        }
      </ul>
    </li>}
  </>;
});
